import { pjaxConfig, computeMaxBlocks } from './pjax/_config.js';
import { collections } from './pjax/_collections.js';
import { afterPageChange, resizeProducts } from './pjax/_afterPageChange.js';
import { visitLog } from './_log.js';
//import { dailyVisited } from './_visited_daily.js';
import { shopifyInit } from './_shopify_init.js';

// カスタムエレメントの定義待ちをフックに登録
shopifyInit.addHook('post', (scope) => {
	const tags = ['product-info','product-form','variant-selects','pickup-availability'];
	if (window.customElements?.whenDefined) {
		Promise.all(tags.map(n => customElements.whenDefined(n).catch(()=>{}))).then(() => {
			// 定義済みなら variant-change を確実に発火させる
			scope.querySelectorAll('variant-selects select, variant-radios input')
				.forEach(el => el.dispatchEvent(new Event('change', { bubbles: true })));
		});
	}
});

class PjaxHandler {
	constructor(options = {}){
		//基本的には_config.jsを参照する
		this.containerSelector = options.container     || pjaxConfig.container     || '#MainContent';
		this.innerSelector     = options.innerSelector || pjaxConfig.innerSelector || '.page_content_inner';
		
		this.linkSelectors = Array.isArray(options.linkSelector) ? options.linkSelector : (options.linkSelector ? [options.linkSelector] : (pjaxConfig.linkSelectors || ['a[data-pjax]']));
		this.ignoreSelectors = options.ignoreSelectors || pjaxConfig.ignoreSelectors || [
			'.no-pjax',
			'[data-no-pjax="true"]',
			'[data-pjax="false"]',
			'a[rel~="external"]',
			'variant-selects a',
			'variant-selects [role="option"]',
			'[data-variant-link]',
			'product-info a[data-update-url="true"]'
		];
		this.backSelector  = options.backSelector  || pjaxConfig.backSelector  || '.js-back';
		this.blockSelector = options.blockSelector || pjaxConfig.blockSelector || 'div[data-page]';
		//URL
		this.topUrl       = options.topUrl || pjaxConfig.topUrl || '/';
		this.maxBlocks    = this._computeMaxBlocks();  // ← 中で computeMaxBlocks() を使う
		
		this.urlStack          = [location.href];                 // URLスタック
		
		this.containerEl = document.querySelector(this.containerSelector);
		if (!this.containerEl) throw new Error(`Container not found: ${this.containerSelector}`);

		// 差し込み先：#MainContent .page_content_inner があればそこ、なければ #MainContent
		this.targetEl = this.innerSelector
			? (this.containerEl.querySelector(this.innerSelector) || this.containerEl)
			: this.containerEl;

		this.cache     = new Map();
		this.isLoading = false;
		this.abortCtrl = null;

		this.onClick   = this.onClick.bind(this);
		this.onPop     = this.onPop.bind(this);
		
		this._frozenY = new WeakMap();   // 各ブロックの保存スクロール量
		this._frozenStyle = new WeakMap(); // 元のstyle属性を退避（解凍で戻す）
		this._stickyStyle = new WeakMap();     // sticky_header用: 元style退避
		this._headerH = (document.querySelector('header#global_header')?.clientHeight) || 0;
		this.freezeTargetSelector =　options.freezeTargetSelector || pjaxConfig.freezeTargetSelector || ':scope > section, :scope > div';   // ← 好きに調整OK
		this.sLog = document.querySelector("#s-log");
		//resize
		this.onResize  = this._debounce(this._handleResize.bind(this), 150);
		//defailt document.title
		this.defaultTitle = document.querySelector("#top_content").getAttribute("data-title");
		
		const meta = this._getCategoryMeta(this.targetEl);
		if (meta) visitLog.add({ url: location.href, title: document.title, ...meta });
		
		this.bindEvents();
		afterPageChange({
			rootEl: this.targetEl,
			blockSelector: this.blockSelector,
			ensureProductInfo: this._ensureProductInfo.bind(this),
			scope: this.targetEl,
			reason: 'init'
		});
	}

	bindEvents(){
		// 委譲方式：DOM差し替え後も再バインド不要
		document.addEventListener('click', this.onClick, true);
		window.addEventListener('popstate', this.onPop);
		
		window.addEventListener('resize', this.onResize, false);
		//console.log("bind events");
	}

	destroy(){
		document.removeEventListener('click', this.onClick, true);
		window.removeEventListener('popstate', this.onPop);
		// ▼ 追加
		window.removeEventListener('resize', this.onResize);
		if (this.abortCtrl) this.abortCtrl.abort();
	}
	// ====== ここから追加のユーティリティ ======
	_computeMaxBlocks(){
		return computeMaxBlocks(window.innerWidth, pjaxConfig);
	}
	
	_handleResize(){
		resizeProducts.title();
		setTimeout(function(){
			resizeProducts.title();
		}, 600);
		this._headerH = (document.querySelector('header#global_header')?.clientHeight) || 0;
		const next = this._computeMaxBlocks();
		if (next === this.maxBlocks) return;
		this.maxBlocks = next;
		// data-block-num を再計算
		this.updateBlockNumAttr();
		// 超過していたら先頭から削除
		this.trimBlocks();
	}
	
	_debounce(fn, wait = 100){
		let t = null;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn(...args), wait);
		};
	}
	// ====== 追加ここまで ======

	onClick(e){
		// ★ 追加: #top_content の素地クリックで全てはける
		{
			const topLayer = document.getElementById('top_content');
			const hasOverlays = this.targetEl.querySelectorAll(this.blockSelector).length > 0;
		
			// UIコントロールはスルー
			const isUiControl = !!e.target.closest('a, button, input, select, textarea, label, [role="button"]');
			// オーバーレイ(data-page)内のクリックはここでは処理しない
			const clickedInsideOverlay = !!e.target.closest(this.blockSelector);
		
			if (topLayer && hasOverlays && !isUiControl && !clickedInsideOverlay && topLayer.contains(e.target)) {
				e.preventDefault();
				// 履歴に積まない（replace）でトップへ
				this.clearToTop({ push: false, fromPop: false });
				return;
			}
		}

		// ★ 追加: 下の（非アクティブ）ページをクリックしたら、そのページまで一気に戻す
		{
			const clickedBlock = e.target.closest(this.blockSelector);
			if (clickedBlock) {
				const blocks = Array.from(this.targetEl.querySelectorAll(this.blockSelector));
				const idx = blocks.indexOf(clickedBlock);
				const lastIdx = blocks.length - 1;
				
				// a / フォーム系 UI 上のクリックはスルー（既存の処理に任せる）
				const isUiControl = !!e.target.closest('a, button, input, select, textarea, label, [role="button"]');
				// “自分が最前じゃない”ページの素地クリックのみハンドリング
				if (idx > -1 && idx !== lastIdx && !isUiControl) {
					e.preventDefault();
					const howMany = lastIdx - idx; // 重なっている枚数分
					//console.log(howMany)
					this.backMany(howMany);       // ← まとめて戻す
					return;
				}
			}
		}
		// 先に「戻る」ボタンを判定
		const back = e.target.closest(this.backSelector);
		if (back){
			e.preventDefault();
			this.backOne();
			// 履歴も戻したい場合はここで history.back() を呼ぶオプションも可
			// if (this.historyBackOnClick) history.back();
			return;
		}
		//---------------------------------------------------------
		// Collection Category Click
		//---------------------------------------------------------
		const cat = e.target.closest('.js-collection_category');
		if (cat) {
			e.preventDefault();
		
			// hrefまたはdata-hrefなどを取得
			const href = cat.getAttribute('href') || cat.dataset.href;
			if (!href) return;
		
			// console.log('[pjax] collection category clicked', href);
		
			// もしcollections.select()が定義されていれば呼ぶ
			if (typeof collections?.select === 'function') {
				collections.select(href);
			} else {
				console.warn('[pjax] collections.select is not defined');
			}
		
			return; // ← これで他のリンク処理（navigateなど）に行かない
		}
		//---------------------------------------------------------
		
		let a = null;
		for (const sel of this.linkSelectors) {
			const candidate = e.target.closest(sel);
			if (candidate) { a = candidate; break; }
		}
		if (!a) return;
		
		// ★ 除外セレクタに該当 → スルー（PJAXしない）
		if (this.ignoreSelectors.some(sel => a.matches(sel))) return;
		
		// ★ 修飾キー（新規タブ/別挙動）→ スルー
		if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
		
		// 同一ページ内アンカー → スルー
		if (a.getAttribute('href')?.startsWith('#')) return;

		//トップへの遷移をフック
		const url = new URL(a.href, location.origin);
		if (url.origin !== location.origin || a.target === '_blank' || a.hasAttribute('download') ) return;
		const isProductInfo = a.closest('product-info');
		const hasVariantParam = /\bvariant=\d+/.test(url.search);
		if (isProductInfo && hasVariantParam) return;
		if (this.urlsEqual(url, this.topUrl)) {
			e.preventDefault();
			// 「トップへ」のクリック時：ブロックを履いてから全削除（history.push も実施）
			this.clearToTop({ push: true, fromPop: false });
			return;
		}
		
		e.preventDefault();
		this.navigate(url.toString(), { push: true });
		let $html = document.documentElement;
		if( $html.classList.contains("show-nav") ){
			$html.classList.remove("show-nav");
		}
	}

	onPop(){
		// 既存ブロックがあるならフェッチせず1つ戻す（URLはブラウザが進め済）
		const atTop = this.urlsEqual(location.href, this.topUrl);
		const hasBlocks = this.targetEl.querySelectorAll(this.blockSelector).length > 0;
		if (atTop) {
			// ブラウザ戻るでトップに来た：ブロック全削除（history はブラウザが進めているので replace のみ）
			this.clearToTop({ push: false, fromPop: true });
			return;
		}
		
		if (hasBlocks) {
			this.backOne({ fromPop: true });
		} else {
			//history.replaceState({}, '', this.topUrl);
		}
	}

	async navigate(url, { push }){
		let $this = this;
		if (this.isLoading) return;
		this.isLoading = true;

		try{
			const html  = await this.fetchHtml(url);
			const block = this.extractBlock(html);
			if (!block) throw new Error('PJAX: div[data-page] が見つかりませんでした');
			
			// 直前までの最前面（＝既存の最後の data-page）を固定
			const existingPages = this.targetEl.querySelectorAll(this.blockSelector);
			let prevTop = existingPages[existingPages.length - 1] || null;
			
			// 💡 トップページ（#top_content）を固定対象に追加
			if (!prevTop) {
			  const topBlock = document.querySelector('#top_content');
			  if (topBlock) {
				prevTop = topBlock;
				console.log('[pjax] freeze target switched to #top_content');
			  }
			}
			
			if (prevTop) this._freezeBlock(prevTop);
			
			// ★ 既存の full-width が active なら外す（順序は変えない）
			await this.removeFullWidthIfExists();
			
			// head からタイトルを取る > あとで取得先を変更する
			const head   = this.extractHead(html);
			const title  = head.title || '';
			
			//ブロックが現在なければトップのコンテンツを固定させる
			this.targetEl.classList.add("loading");
			this.sLog.classList.add("loading");
			const $pageContent = document.querySelector("#page_content");
			const $container 	= document.querySelector("#MainContent");
			if( !$container.classList.contains("has-page")){
				$container.classList.add("has-page")
			}
			//
			// 同じ data-page が既にあるなら重複を避ける（任意）
			const key = block.getAttribute('data-page');
			if (key){
				this.targetEl.querySelectorAll(this.blockSelector).forEach(el => {
					if (el.getAttribute('data-page') === key) el.remove();
				});
			}
			// このブロックが表すURLとタイトルを刻む
			block.setAttribute('data-url', url);
			block.setAttribute('data-title', title);
			this._setTitle(title);
			
			block.classList.remove("active");
			// 末尾に追加
			this.targetEl.appendChild(block);
			
			// 追加したブロック範囲で Shopify 再初期化  ← これが“fetch後”の再初期化
			shopifyInit.reinit(block); // ← 追加
			//辞書のみログ登録
			/*
			{
				const dict = block.querySelector('.page_dictionary');
				
				if (dict){
					const titleJa = block.querySelector('.c-ttl_page h2 span.ja')?.textContent || '';
					const titleEn = block.querySelector('.c-ttl_page h2 span.en')?.textContent || '';
					const categoryName = dict.dataset?.categoryName;
					const categorySlug = dict.dataset?.categorySlug;
					
					dailyVisited.add({
						url,
						titleJa,
						titleEn,
						categoryName,
						categorySlug
					});
				}
			}
			*/
			
			// pushState
			if (push) {
				history.pushState({}, '', url);
				this.urlStack.push(url);
			}
			/*
			ログ追加
			あとでカテゴリを追加する
			*/
			//visitLog.add({ url, title });
			const meta = this._getCategoryMeta(block);
			if (meta) visitLog.add({ url, title, ...meta });
			
			// スクロール（好みで）
			//window.scrollTo({ top: 0, behavior: 'auto' });
			let num = this.targetEl.querySelectorAll(this.blockSelector).length; // ★セレクタ統一
			num = num >= this.maxBlocks ? this.maxBlocks : num;
			//console.log(this.maxBlocks);
			$pageContent.setAttribute("data-block-num", num);
			// 新しく追加したブロックにactiveを付与
			//window.scrollTo({ top: 0, behavior: 'auto' });
			//window.scrollTo(0, 0);
			setTimeout(function(){
				// 最大数を超えたら先頭から削除
				$this.trimBlocks();
				block.classList.add('active');
				window.scrollTo(0, 0);
				setTimeout(function(){
					//block.classList.add('active');
					
					block.addEventListener("transitionend", function(){
						$this._ensureProductInfo(block);
						afterPageChange({
							rootEl: $this.targetEl,
							blockSelector: $this.blockSelector,
							ensureProductInfo: $this._ensureProductInfo.bind($this),
							scope: block,
							reason: 'navigate'
						});
						$this.targetEl.classList.remove("loading");
						$this.sLog.classList.remove("loading");
						//window.scrollTo({ top: 0, behavior: 'smooth' });
					}, { "once": true });
				}, 50);
			}, 400);
			// 必要ならここでテーマ再初期化など
			// document.dispatchEvent(new Event('shopify:section:load'));

		} catch(err){
			console.error('[PjaxHandler]', err);
			// 必要ならフォールバック
			// location.href = url;
		} finally{
			this.isLoading = false;
		}
	}

	async fetchHtml(url){
		// 前回のリクエストを中断
		if (this.abortCtrl) this.abortCtrl.abort();
		this.abortCtrl = new AbortController();

		// キャッシュ利用（任意）
		if (this.cache.has(url)) return this.cache.get(url);

		const res  = await fetch(url, {
			signal: this.abortCtrl.signal,
			headers: { 'X-Requested-With': 'PjaxHandler' },
			credentials: 'same-origin'
		});
		if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);

		const html = await res.text();
		this.cache.set(url, html);
		return html;
	}

	extractBlock(html){
		// 取得したHTMLから差し込み対象のブロックだけ抜き出す
		const doc = document.implementation.createHTMLDocument('');
		doc.documentElement.innerHTML = html;

		// まずは“相手側の” container.innerSelector の中を探す
		const srcContainer = this.innerSelector
			? (doc.querySelector(`${this.containerSelector} ${this.innerSelector}`) ||
			   doc.querySelector(this.containerSelector) || doc)
			: (doc.querySelector(this.containerSelector) || doc);

		const srcBlock = srcContainer.querySelector(this.blockSelector);
		if (!srcBlock) return null;

		// クローンして現在DOMへ安全に移植
		const wrap = document.createElement('div');
		wrap.innerHTML = srcBlock.outerHTML;
		return wrap.firstElementChild;
	}
	extractHead(html){
		const doc = document.implementation.createHTMLDocument('');
		doc.documentElement.innerHTML = html;
		const titleEl = doc.querySelector('title');
		const title = titleEl ? titleEl.textContent : '';
		return { title };
	}
	trimBlocks(){
		const blocks = this.targetEl.querySelectorAll(this.blockSelector);
		const over   = blocks.length - this.maxBlocks;
		for (let i = 0; i < over; i++){
			const first = blocks[i];
			const firstUrl = first.getAttribute('data-url');
			
			// unload をブロック破棄前に通知  ← 追加
			shopifyInit.unload(first);
			
			// URLスタックとログも同期して先頭を落とす
			if (this.urlStack.length > 1 && this.urlStack[0] === firstUrl) {
				this.urlStack.shift();
			}
			visitLog.removeFirstByUrl(firstUrl);
			first.remove();
		}
		this.updateBlockNumAttr();
	}
	// ← 追加：任意枚数戻す汎用関数を下で定義（backMany）
	// ← 変更：一つ前に戻る（最後尾の active ブロックを消す）
	backOne({ fromPop = false } = {}){
		// ★ 変更: 実装は backMany(1) に委譲
		return this.backMany(1, { fromPop });
	}
	
	// ★ 追加: 末尾から n 枚まとめて“はける” 2025.10.01
	async backMany(n, { fromPop = false } = {}){
		const blocksAll = Array.from(this.targetEl.querySelectorAll(this.blockSelector));
		if (!blocksAll.length || n <= 0) return;
		
		const toRemove = blocksAll.slice(-n);
		this.targetEl.classList.add('back');
		
		// 1) active を外して CSS トランジションで“はける”
		toRemove.forEach(el => el.classList.remove('active'));
		
		// 2) すべてのトランジション終了を待つ（フェイルセーフ付）
		await Promise.all(toRemove.map(el => this._waitTransition(el, 500)));
	
		// 3) unload → 削除、スタック/ログ同期（末尾から）
		for (const el of toRemove) {
			// 固定されていたら消す前に念のため印を外しておく（styleは remove() で消えるが保険）
			if (el.dataset?.frozen === '1') {
				el.dataset.frozen = '0';
			}
			try { shopifyInit.unload(el); } catch {}
			const removedUrl = el.getAttribute('data-url');
			el.remove();
			
			// URLスタック（末尾想定）：一致時はpop、ズレてても整合用にpop
			if (this.urlStack.length > 1 && this.urlStack[this.urlStack.length - 1] === removedUrl) {
				this.urlStack.pop();
			} else if (this.urlStack.length > 1) {
				this.urlStack.pop();
			}
			if( visitLog.backDelete ){
				visitLog.popLast?.();
			}
		}
		
		// 4) 新しい末尾に active
		const rest = Array.from(this.targetEl.querySelectorAll(this.blockSelector));
		const last = rest[rest.length - 1];
		if (last) {
			last.classList.add('active');
			// ★ 新しく最前面になったブロックは解凍し、スクロールを引き継ぐ
			this._thawBlock(last);
		}
		// 固定解除
		const topBlock = document.querySelector('#top_content');
		if (topBlock) {
			this._thawBlock(topBlock);
			console.log('[pjax] thawed top_content');
		}
		
		this._setTitle(last?.getAttribute('data-title'));
		// 5) URL を合わせる
		const nextUrl = last ? (last.getAttribute('data-url') || this.topUrl) : this.topUrl;
		if (!fromPop) {
			history.replaceState({}, '', nextUrl);
		} else if (!rest.length) {
			history.replaceState({}, '', this.topUrl);
		}
	
		// 6) カウンタ/見た目後処理
		this.updateBlockNumAttr();
		this.targetEl.classList.remove('back');
		requestAnimationFrame(() => {
			logToTop();
		});
		setTimeout(function(){
			logToTop
		}, 200);
		// 7) 共通後処理フック
		afterPageChange({
			rootEl: this.targetEl,
			blockSelector: this.blockSelector,
			ensureProductInfo: this._ensureProductInfo.bind(this),
			scope: last || null,
			reason: 'back-many'
		});
		function logToTop(){
			let logContainer = document.querySelector("#s-log .s-inner");
			logContainer.scrollTop = "0px";
		}
	}
	
	updateBlockNumAttr(){
		const $pageContent = document.querySelector("#page_content");
		if (!$pageContent) return;
		const len = this.targetEl.querySelectorAll(this.blockSelector).length;
		$pageContent.setAttribute("data-block-num", Math.min(len, this.maxBlocks));
		let $container = document.querySelector("#MainContent");
		if( len === 0 ){
			$container.classList.remove("has-page")
		}
	}
	//
	urlsEqual(a, b) {
		const A = new URL(a, location.origin);
		const B = new URL(b, location.origin);
		// 末尾スラッシュやクエリの違いを好みに合わせて調整
		return A.origin === B.origin && A.pathname.replace(/\/+$/, '') === B.pathname.replace(/\/+$/, '');
	}
	
	async clearToTop({ push = false, fromPop = false } = {}) {
		const blocks = Array.from(this.targetEl.querySelectorAll(this.blockSelector));
		if (!blocks.length) {
			// ブロックがそもそも無い時は URL だけ揃える
			if (!fromPop) {
				push ? history.pushState({}, '', this.topUrl) : history.replaceState({}, '', this.topUrl);
			}
			this.updateBlockNumAttr();
			return;
		}
		
		// 見た目用フラグ
		this.targetEl.classList.add('back');
		
		setTimeout(function(){
			// 1) active を外してはけるトランジション開始
			blocks.forEach(el => el.classList.remove('active'));
		}, 50);
		
		
		// 2) アニメーション完了を (最大) 待つ
		await new Promise(resolve => setTimeout(resolve, 400)); // 必要なら調整
		
		// 3) unload → 削除、スタックとログを同期して全消し
		for (const el of blocks) {
			if (el.dataset?.frozen === '1') {
				el.dataset.frozen = '0';
			}
			const url = el.getAttribute('data-url');
			try { shopifyInit.unload(el); } catch {}
			el.remove();
		
			// urlStack: 先頭/末尾に同じURLが重複していても全て掃除
			this.urlStack = this.urlStack.filter(u => u !== url);
			visitLog.removeFirstByUrl(url); // 先頭一致を1件消す実装なら必要に応じて繰り返し
		}
		
		// 最低1件は現在URLを入れておきたい場合はリセット
		this.urlStack = [new URL(this.topUrl, location.origin).toString()];
		
		// 4) URL を / に揃える
		if (!fromPop) {
			push ? history.pushState({}, '', this.topUrl) : history.replaceState({}, '', this.topUrl);
		} else {
			history.replaceState({}, '', this.topUrl);
		}
		// 固定解除
		const topBlock = document.querySelector('#top_content');
		if (topBlock) {
			this._thawBlock(topBlock);
			console.log('[pjax] thawed top_content');
		}
		
		// 5) UI後片付け
		this.targetEl.classList.remove('back');
		const $container = document.querySelector('#MainContent');
		$container?.classList.remove('has-page');
		this.updateBlockNumAttr();
		this._setTitle(this.defaultTitle);
		afterPageChange({
			rootEl: this.targetEl,
			blockSelector: this.blockSelector,
			ensureProductInfo: this._ensureProductInfo.bind(this),
			scope: null,
			reason: 'clear'
		});
	}
	// トランジション終了待ち（フェイルセーフ付）
	_waitTransition(el, timeout = 600){
		return new Promise(resolve => {
			let done = false;
			const onEnd = () => {
				if (done) return;
				done = true;
				el.removeEventListener('transitionend', onEnd);
				resolve();
			};
			el.addEventListener('transitionend', onEnd, { once: true });
			setTimeout(onEnd, timeout); // フェイルセーフ
		});
	}
	// 既存の .full-width を「履いてから」DOM削除し、カウンタ更新
	async removeFullWidthIfExists(){
		const fw = this.targetEl.querySelector(`${this.blockSelector}.full-width`);
		if (!fw) return;
		
		// はける（activeを外す）
		fw.classList.add("delete");
		setTimeout(function(){
			fw.classList.remove('active');
		}, 50)
		
		
		// トランジションが終わるまで待つ
		await this._waitTransition(fw, 600);
		
		// unloadして削除
		try { shopifyInit.unload(fw); } catch {}
		const url = fw.getAttribute('data-url');
		fw.remove();
		
		// urlStack / ログ同期
		if (url) {
			this.urlStack = this.urlStack.filter(u => u !== url);
				visitLog.removeFirstByUrl(url); // 同URLが複数ある可能性があれば繰り返し削除に変更可
			}
			
			// data-block-num などを更新
			this.updateBlockNumAttr();
			
			// has-page の後片付け（0枚になったら外す）
			const $container = document.querySelector('#MainContent');
			if (!this.targetEl.querySelector(this.blockSelector)) {
			$container?.classList.remove('has-page');
		}
	}
	_getCategoryMeta(scope = document) {
		const dictionaryEl 	= scope.querySelector?.('.page_dictionary');
		const productEl 	= scope.querySelector(".product_detail");
		let name, slug, title_en, title_ja, color, productTitle;
		if( dictionaryEl ){
			name = dictionaryEl.dataset?.categoryName;
			slug = dictionaryEl.dataset?.categorySlug;
			productTitle 	= "";
			title_en = scope.querySelector?.(".c-ttl_page h2 span.en").textContent;
			title_ja = scope.querySelector?.(".c-ttl_page h2 span.ja").textContent;
			color = dictionaryEl.getAttribute("data-category-color");
		}else if( productEl ){
			name = productEl.getAttribute("data-category-name");
			slug = productEl.getAttribute("data-category-slug");
			productTitle 	= scope.querySelector(".product__title h2.c-ttl_type span").textContent;
			title_en = scope.querySelector?.(".product__title h3 span.en").textContent;
			title_ja = scope.querySelector?.(".product__title h3 span.ja").textContent;
			color = productEl.getAttribute("data-category-color");
		}
		if (name && slug) return { categoryName: name, categorySlug: slug, titleJa: title_ja, titleEn: title_en, color: color, productTitle: productTitle };
		return null;
	}
	/* 2025.09.25
	product-infoが呼ばれないときの念押し
	shopifyInitの方にも_evalInlineScriptsOnceを追加して、外部スクリプトにdata-reinit="external"をつけることでpjaxで読み込みしたときに再読み込みさせる
	*/
	_ensureProductInfo(scope){
		// 重複防止（この scope で一度だけ）
		if (scope.dataset.ensurePiDone === '1') return;
		scope.dataset.ensurePiDone = '1';
		
		const kick = () => {
			// scope 内の product-info に対して“念押し change”を投げる
			scope.querySelectorAll('product-info').forEach((pi) => {
				if (pi.dataset.ensured === '1') return;
				pi.dataset.ensured = '1';
			
				const target =
				pi.querySelector('variant-radios input:checked') ||
				pi.querySelector('variant-selects select[name^="options"]') ||
				pi.querySelector('select[name="id"]');
			
				if (target) {
					// レイアウト確定後に 1フレーム遅らせて発火（描画・アニメ干渉なし）
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							target.dispatchEvent(new Event('change', { bubbles: true }));
						});
					});
				}
			});
		};
	
		// customElements が無い環境でも進める
		if (!window.customElements || typeof customElements.get !== 'function') {
			kick();
			return;
		}
	
		// すでに定義済みなら即実行
		if (customElements.get('product-info')) {
			kick();
			return;
		}
	
		// ここまで来たら「未定義」。whenDefined とタイムアウトのレースにする
		let settled = false;
	
		// 2秒経っても未定義なら、定義を諦めて最後の手段として kick（最低限の更新だけでも）
		const timer = setTimeout(() => {
			if (settled) return;
			settled = true;
			console.warn('[ensureProductInfo] product-info was not defined in time; running fallback kick()');
			kick();
		}, 2000);

		// whenDefined：定義されたら実行
		try {
			customElements.whenDefined('product-info').then(() => {
				if (settled) return;
				settled = true;
				clearTimeout(timer);
				kick();
			}).catch(() => {
				if (settled) return;
				settled = true;
				clearTimeout(timer);
				kick();
			});
		} catch (e) {
			// ブラウザ実装差や例外時も止まらない
			clearTimeout(timer);
			kick();
		}
	}
	
	// ブロックを現在の見た目の位置で固定する
	_freezeBlock(block){
		const el = this._getFreezeTarget(block);
		if (!el || el.dataset.frozen === '1') return;
		if( window.innerWidth < 960 ){
			if( el.getAttribute("id") === "snapper" ){
				return;
			}
		}
		const sticky = block.querySelector('.sticky_header');
		
		// 位置計算は1回ずつ
		const rect = el.getBoundingClientRect();
		const docTop = rect.top + window.scrollY;
		this._headerH = document.querySelector("header#global_header").clientHeight;
		//const relScrollY = window.scrollY - docTop + this._headerH;
		let relScrollY = window.scrollY;
		if( sticky ){
			console.log("sticky", sticky.clientHeight)
			relScrollY = window.scrollY - sticky.clientHeight;
		}
		//console.log(window.scrollY);
			
		// 親の元styleを退避
		this._frozenStyle.set(el, el.getAttribute('style') || '');
	
		// --- 視覚の安定化 ---
		// fixed化/translate時に横ズレや再フローが出ないよう幅とleftを固定
		//el.style.width = rect.width + 'px';
		//el.style.left  = rect.left + 'px';
		
		// topよりtransformの方が合成レイヤーに乗ってチラつきにくい
		// ※ position:fixed はCSS側（[data-frozen="1"] など）で与える前提
		el.style.transform = `translateY(${-relScrollY}px)`;
		el.style.pointerEvents = 'none';
		el.style.willChange = 'transform';
		el.dataset.frozen = '1';
		
		let relativeR = el.querySelector(".b-relative");
		if( relativeR ){
			relativeR.style.transform = `translateY( calc(${relScrollY}px) )`;
			//relativeR.querySelector(".relative_inner").style.transform = `translateY( calc(${relScrollY*-1}px) )`;
		}
		
		
		// sticky_header 調整（任意：あなたの方針を踏襲）
		if (sticky){
			// 元styleを退避
			this._stickyStyle.set(sticky, sticky.getAttribute('style') || '');
			
			// 視覚のギャップをなくす：固定中は親のtransformに追随しない座標で置く
			// 「親fixedの中でabsolute/top」でもOKですが、より安定させるなら viewport基準で固定
			const sRect = sticky.getBoundingClientRect();
			Object.assign(sticky.style, {
				position: 'absolute',
				top:      relScrollY + 'px',    // 今見えている位置をそのまま保持
				margin:   0,
				transform: 'translateZ(0)',      // 文字ブレ対策
				willChange: 'transform',
				pointerEvents: 'none'
			});
		}
		
		// 保存（スクロール復元用）
		this._frozenY.set(el, relScrollY);
}
	
	// 固定を解いて通常スクロールに戻す（そのブロックが最前面になったタイミングで呼ぶ）
	_thawBlock(block){
		const el = this._getFreezeTarget(block);
		if (!el || el.dataset.frozen !== '1') return;
		
		const sticky = block.querySelector('.sticky_header');
		const relScrollY = this._frozenY.get(el) || 0;
		
		// stickyを先に元へ戻す
		if (sticky){
			const prevSticky = this._stickyStyle.get(sticky) || '';
		if (prevSticky) sticky.setAttribute('style', prevSticky);
			else sticky.removeAttribute('style');
			this._stickyStyle.delete(sticky);
		}
		
		// 親のstyle復元
		const prev = this._frozenStyle.get(el) || '';
		if (prev) el.setAttribute('style', prev);
		else el.removeAttribute('style');
		let relativeR = el.querySelector(".b-relative");
		if( relativeR ){
			relativeR.removeAttribute('style');
			//relativeR.querySelector(".relative_inner").removeAttribute('style');
		}
		
		el.dataset.frozen = '0';
		this._frozenY.delete(el);
		this._frozenStyle.delete(el);
		
		// thaw後のDOMに合わせてスクロール復元（次フレームが安定）
		requestAnimationFrame(() => {
			const newDocTop = el.getBoundingClientRect().top + window.scrollY;
			let $header = document.querySelector("#global_header");
			let headerH = $header.clientHeight;
			
			let stickyHeader = el.querySelector(".sticky_header");
			let stickyH = 0;
			if( stickyHeader ){
				stickyH = stickyHeader.clientHeight;
			}
			const targetY = newDocTop + relScrollY - headerH + stickyH;
			//console.log(targetY);
			window.scrollTo(0, targetY);
		});
	}
	// クラスメソッドとして追加
	/*
	_getFreezeTarget(block){
		if (!block) return null;
		// data-freeze-target があればそれを最優先（任意）
		const explicit = block.querySelector(':scope > [data-freeze-target]');
		if (explicit) return explicit;
		
		// セレクタで直下の候補から最初の1つを使う
		return block.querySelector(this.freezeTargetSelector);
	}
	*/
	_getFreezeTarget(block) {
		//console.log("getFREEZE:", block);
		if (!block) return null;
	
		// ==============================
		// 💡 トップコンテンツの固定（下層から参照）
		// 下層ページ (#page_content 配下) のときでも
		// #top_content .c-list_items を対象にする
		// ==============================
		const isUnderPage = !!block.closest('#page_content');
		const hasPages = document.querySelectorAll('#page_content [data-page]').length > 0;
		
		if (isUnderPage && !hasPages) {
			const top = document.querySelector('#top_content');
			if (top) {
				console.log('[pjax] freeze target: #top_content (first sub page)');
				return top;
			}
		}
	
		// ==============================
		// data-freeze-target 属性がある場合は優先
		// ==============================
		const explicit = block.querySelector(':scope > [data-freeze-target]');
		if (explicit) return explicit;
	
		// ==============================
		// 通常処理
		// ==============================
		return block.querySelector(this.freezeTargetSelector);
	}
	_setTitle(nextTitle) {
		document.title = nextTitle || this.defaultTitle || '';
	}
}

// 実行（そのまま差し替えOK）
export const pjax = new PjaxHandler({
	...pjaxConfig
});